import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/sw.js");
  });
}

// iOS Home Screen badges are independent of notification permission and remain set until
// the app explicitly clears them. Opening Turnstyle means the player has seen the update.
const clearAppBadge = () => {
  if ("clearAppBadge" in navigator) void navigator.clearAppBadge();
};

window.addEventListener("focus", clearAppBadge);
document.addEventListener("visibilitychange", () => {
  if (document.visibilityState === "visible") clearAppBadge();
});
